"use client";

import { FaqType } from "@/graphql/queries/faqs-query";
import { useParams, usePathname } from "next/navigation";

const useFaqParams = () => {
  const { course, slug, country, city } = useParams<{
    course: string;
    slug: string;
    country: string;
    city: string;
  }>();

  const pathname = usePathname();

  let faqType = FaqType.GENERAL;
  if (pathname.includes(course)) {
    faqType = FaqType.COURSES;
  }
  if (pathname.includes(slug)) {
    faqType = FaqType.CONSULTING;
  }

  return {
    faqType: faqType as FaqType,
    slug: course || slug,
    country,
    city,
  };
};

export default useFaqParams;
